import { render, staticRenderFns } from "./TagModal.vue?vue&type=template&id=58ec5f33&"
import script from "./TagModal.vue?vue&type=script&lang=js&"
export * from "./TagModal.vue?vue&type=script&lang=js&"
import style0 from "./TagModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports